import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./Nwreu.module.css";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import Loader from "../Loader/Loader";

const ITEMS_PER_PAGE = 20;

const Nwreu = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://nwreu-backend-seven.vercel.app/pnm-nwreu"
        );

        // Sort latest first (KEEP LOGIC)
        const sortedData = response.data.sort((a, b) => {
          const dateA = parseDate(a.date);
          const dateB = parseDate(b.date);
          return dateB - dateA;
        });

        setData(sortedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Parse date helper
  const parseDate = (dateString) => {
    const [day1, day2, month, year] = dateString
      .replace(".", "")
      .split(/[-\s]/);

    const date1 = new Date(`${month} ${day1}, ${year}`);
    const date2 = new Date(`${month} ${day2}, ${year}`);

    return date2 > date1 ? date2 : date1;
  };

  // Pagination logic
  const totalPages = Math.ceil(data.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentData = data.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  // Compact pagination numbers
  const getPageNumbers = () => {
    const pages = [];
    const delta = 2;

    const left = Math.max(2, currentPage - delta);
    const right = Math.min(totalPages - 1, currentPage + delta);

    pages.push(1);

    if (left > 2) pages.push("...");

    for (let i = left; i <= right; i++) {
      pages.push(i);
    }

    if (right < totalPages - 1) pages.push("...");

    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  return (
    <div className={styles.TableContainer}>
      <span>
        <h2 className={styles.textColour}>
          महाप्रबंधक स्तरीय स्थाई वार्ता तंत्र - GM Level Permanent Negotiating
          Machinery
        </h2>
      </span>

      <Link to="/AgendaItems">
        <span>
          <h2>GM PNM Agenda Items (Click Here)</h2>
          <FaArrowRight />
        </span>
      </Link>

      {loading ? (
        <Loader />
      ) : (
        <>
          <table className={styles.membersTable}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Minutes</th>
                <th>Outset & Reply</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((item, index) => (
                <tr key={startIndex + index}>
                  <td>{item.date}</td>
                  <td>
                    <a
                      href={item.minutesLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.noDecoration}
                    >
                      {item.minutes}
                    </a>
                  </td>
                  <td>
                    <a
                      href={item.outsetReplyLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.noDecoration}
                    >
                      {item.outsetReply}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className={styles.pagination}>
            <button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>

            {getPageNumbers().map((page, index) =>
              page === "..." ? (
                <span key={index} className={styles.ellipsis}>
                  …
                </span>
              ) : (
                <button
                  key={index}
                  className={
                    currentPage === page ? styles.activePage : styles.pageBtn
                  }
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              )
            )}

            <button
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>

            <span className={styles.jump}>
              Go to:
              <input
                type="number"
                min="1"
                max={totalPages}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const value = Number(e.target.value);
                    if (value >= 1 && value <= totalPages) {
                      setCurrentPage(value);
                    }
                  }
                }}
              />
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default Nwreu;
